export type TicketState = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;
interface ITicketStateEnum {
    NotPrinted: TicketState;
    Waiting: TicketState;
    Invited: TicketState;
    Serviced: TicketState;
    Served: TicketState;
    Removed: TicketState;
    Stopped: TicketState;
    Deleted: TicketState;
    getName(): string;
    format(value: number): string | undefined;
}

const datasource = () => [
    { id: 0, name: 'Neatspausdintas', code: null, type: null, group: null },
    { id: 1, name: 'Laukia', code: null, type: null, group: null },
    { id: 2, name: 'Kviečiamas', code: null, type: null, group: null },
    { id: 3, name: 'Aptarnaujamas', code: null, type: null, group: null },
    { id: 4, name: 'Aptarnautas', code: null, type: null, group: null },
    { id: 5, name: 'Pašalintas', code: null, type: null, group: null },
    { id: 6, name: 'Sustabdytas', code: null, type: null, group: null },
    { id: 7, name: 'Ištrintas', code: null, type: null, group: null }
];

export const ticketState: ITicketStateEnum = {
    NotPrinted: 0,
    Waiting: 1,
    Invited: 2,
    Serviced: 3,
    Served: 4,
    Removed: 5,
    Stopped: 6,
    Deleted: 7,
    getName() {
        return 'TicketState';
    },
    format(value: number) {
        const item = datasource().find((x) => x.id === value);
        return item && item.name;
    }
};
